import { ErrorPage } from './ErrorPage';

export interface ErrorSearchPageProps {}

export const ErrorSearchPage = (props: ErrorSearchPageProps) => {
  return <ErrorPage contentCode="ERROR_SEARCH_CONTENT" />;
};
